import React from "react";

export const Services = (props) => {
  return (
    <div id="services" className="text-center">
      <div className="container">
        <div className="services">
          <h2>Our core services include</h2>
          <h3>
            Here are the details of our significant project
          </h3>
        </div>
        <div className="col-xs-12 col-md-6">
          <div className="list-style">
            <div className="col-lg-10 col-sm-12 col-xs-12  col-md-offset-1">
              <ul>
                <ol><b>System Consultation & Planning</b>
                </ol>
                <ol><b>Digital Transformation</b>
                </ol>
                <ol><b>System Installation & Integration</b>
                </ol>
                <ol><b>Security System & Support</b>
                </ol>
                <ol><b>Training & Knowledge Transfer</b>
                </ol>
              </ul>
            </div>
          </div>
        </div>
        <div className="col-xs-12 col-md-6">
          <div className="col-xs-12 col-md-6">
            <img src="../img/services/03.jpg" alt="..." className="services-img" />
          </div>
          <div className="col-xs-12 col-md-6">
            <img src="../img/services/04.jpg" alt="..." className="services-img" />
          </div>
        </div>

        {/* <div className="row">
          {props.data
            ? props.data.map((d, i) => (
              <div key={`${d.name}-${i}`} className="col-md-3 services-containt">
                {" "}
                <img src={d.img} alt="..." className="service-img" />
                <div className="service-desc">
                  <h3>{d.name}</h3>
                  <p>{d.text}</p>
                </div>
              </div>
            ))
            : "loading"}
        </div> */}
      </div>
    </div >
  );
};
